// 아주 단순한 로그인 상태 저장소 (데모용, 메모리 기반)
const state = {
  customerId: null,
  loginId: null,
  name: null,
  role: null      // admin / staff / customer
};

export function setAuth(user) {
  state.customerId = user.customerId;
  state.loginId = user.loginId;
  state.name = user.name;
  state.role = user.role;
  // 라우터 가드 / API 헤더에서 참조
  window.__AUTH__ = {
    customerId: user.customerId,
    loginId: user.loginId,
    name: user.name,
    role: user.role
  };
}

export function clearAuth() {
  state.customerId = null;
  state.loginId = null;
  state.name = null;
  state.role = null;
  window.__AUTH__ = null;
}

export function getAuth() {
  return state;
}

// admin 전용 권한 (v112: 엑셀 업로드·발생근거 버튼·수동저장 목록 등은 admin 만).
export function isAdmin() {
  return state.role === 'admin';
}

// 전체 조회 가능(모든 행 조회): admin 또는 staff
export function canViewAll() {
  return state.role === 'admin' || state.role === 'staff';
}
